<template>
  <el-drawer title="推送设置" :visible.sync="visible" @close="close" size="1000px" :close-on-press-escape="false"
      :wrapperClosable="false" id="comDrawer" :modal-append-to-body="false">
      <div class="drawerView">
          <div class="drawerViewT">
              <div class="drawerCom">
                  <div class="drawerComL">配置编号:</div>
                  <div class="drawerComR">
                      <el-input v-model="params.templateCode" placeholder="请输配置编号" style="width: 600px"></el-input>
                  </div>
              </div>
              <div class="drawerCom">
                  <div class="drawerComL">配置名称：</div>
                  <div class="drawerComR">
                      <el-input v-model="params.templateName" placeholder="配置名称：" style="width: 600px"></el-input>
                  </div>
              </div>
              <div class="drawerCom">
                  <div class="drawerComL">内容模板：</div>
                  <div class="drawerComR">
                      <el-tooltip class="item" effect="dark" content="模板参数,例如:age,应填写'${age}'" placement="top">
                          <el-input v-model="params.templateContent" :rows="10" type="textarea" style="width: 600px"></el-input>
                      </el-tooltip>
                  </div>
              </div>
          </div>
          <div class="drawerViewB">
              <div class="btn2" @click="close">取消</div>
              <div class="btn" @click="submit">确定</div>
          </div>
      </div>
  </el-drawer>
</template>

<script>
export default {
  data() {
      return {
          showText: false,
          visible: true,

          messageRoute: [],
          params: {},
          // id:''
      };
  },
  props: {
      id: {
          default: '',
      },
  },
  mounted() {
      this.visible = true;
      console.log(this.id, 'this.id');
      if (this.$public.isNull(this.id)) {
          this.params = {
              id: '',
              templateName: "",
              templateContent: "", // 默认内容
              templateCode: "",
             
          };
      } else {
          let param = {
              id: this.id
          }
          this.$http.get(process.env.VUE_APP_Url38 + 'api/WXGZH/Template/Detail', param).then(res => {
              if (res.code == 0) {
                  console.log(res, 'res1111');
                  this.params = res.data;

              }
          })

      }

  },
  methods: {

      change(e) {
          this.$forceUpdate()
      },
  
  
      close() {
          this.$emit("submit", {
              type: "close",
          });
      },
      //提交
      submit() {


          if (this.$public.isNull(this.params.templateName)) {
              this.$message({
                  type: "error",
                  message: "配置名称输入有误",
              });
              return;
          }
          if (this.$public.isNull(this.params.templateContent)) {
              this.$message({
                  type: "error",
                  message: "推送内容输入有误",
              });
              return;
          }
          let params = this.params;
          if (this.$public.isNull(this.id)) {
              this.$http
                  .post(process.env.VUE_APP_Url38 + "api/WXGZH/Template/Create", params)
                  .then((res) => {
                      if (res.code == 0) {
                          this.$message({
                              type: "success",
                              message: "操作成功",
                          });
                          this.$emit("submit", {
                              type: "success",
                          });
                      }
                  });
          } else {
              this.$http
                  .post(process.env.VUE_APP_Url38 + "api/WXGZH/Template/update", params)
                  .then((res) => {
                      if (res.code == 0) {
                          this.$message({
                              type: "success",
                              message: "操作成功",
                          });
                          this.$emit("submit", {
                              type: "success",
                          });
                      }
                  });
          }

      },
  },
};
</script>

<style scoped lang="scss">
#comDrawer {
  ::v-deep .el-drawer__header {
      padding: 20px;
      margin-bottom: 0;
  }

  ::v-deep .el-drawer__body {
      height: calc(100% - 65px);
      overflow-y: auto;
  }
}

.drawerView {
  height: 100%;
  display: flex;
  flex-direction: column;

  .drawerViewT {
      flex: 1;
      box-sizing: border-box;
      border-top: solid 1px #f2f2f2;
      overflow-y: scroll;

      .drawerCom {
          display: flex;
          margin-top: 32px;

          .drawerComL {
              width: 132px;
              margin-right: 22px;
              font-size: 14px;
              color: #343440;
              text-align: right;
              line-height: 20px;
              margin-top: 12px;
          }

          .drawerComR {
              flex: 1;
              line-height: 40px;

              .drawerSelect {
                  display: flex;

                  .drawerSelectItem {
                      width: 128px;
                      height: 44px;
                      box-sizing: border-box;
                      font-size: 14px;
                      color: #69697b;
                      text-align: center;
                      line-height: 44px;
                      position: relative;
                      background: #fafafd;
                      border-radius: 8px;
                      margin-right: 16px;

                      div:nth-of-type(1) {
                          position: absolute;
                          left: 16px;
                          top: 0;
                          bottom: 0;
                          margin: auto 0;
                          width: 16px;
                          height: 16px;
                          border-radius: 100%;
                          border: solid 1px #b0b0bf;
                      }
                  }

                  .drawerSelectActiveItem {
                      width: 128px;
                      height: 44px;
                      box-sizing: border-box;
                      font-size: 14px;
                      color: #577bff;
                      text-align: center;
                      line-height: 44px;
                      position: relative;
                      background: #fafafd;
                      border-radius: 8px;
                      margin-right: 16px;
                      border: 1px solid #577bff;

                      div:nth-of-type(1) {
                          position: absolute;
                          left: 16px;
                          top: 0;
                          bottom: 0;
                          margin: auto 0;
                          width: 4px;
                          height: 4px;
                          border-radius: 100%;
                          border: solid 6px #577bff;
                      }
                  }
              }
          }
      }
  }

  .drawerViewT::-webkit-scrollbar {
      display: none;
  }

  .drawerViewB {
      height: 60px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 20px;
      border-top: solid 1px #f2f2f2;
      box-sizing: border-box;

      .btn {
          width: 98px;
          line-height: 40px;
          text-align: center;
          background: linear-gradient(135deg, #5685ff 0%, #3569ff 100%);
          border-radius: 10px;
          font-size: 16px;
          font-weight: bold;
          color: #fff;
          cursor: pointer;
          margin-left: 20px;
      }

      .btn2 {
          width: 98px;
          line-height: 40px;
          text-align: center;
          border-radius: 10px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          box-sizing: border-box;
          border: solid 1px #577bff;
          color: #577bff;
      }
  }
}</style>
